module.exports = __webpack_public_path__ + "static/media/eggs.89e849f1.jpg";